import React from 'react';
import ContactForm from "./ContactForm";
import { FiHeadphones , FiMail , FiInstagram } from "react-icons/fi";

const ContactOne = () => {
    return (
        <>
            <div className="row row--15">
                <div className="col-lg-12">
                    <div className="rn-contact-address mt_dec--30">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Contact Us On Discord</h4>
                                        <p><a href="https://discord.gg/gGqBq4sx4T" target="_blank">Join Discord</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Contact Us Via Email</h4>
                                        <p><a href="mailto:deluxeeditsbusiness@gmail.com">contact@deluxeedits.com</a></p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiInstagram />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Contact Us On Instagram</h4>
                                        <p><a href="https://www.instagram.com/deluxeeditsofficial/" target="_blank">Visit Our Instagram</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt--40 row--15">
                <div className="col-lg-12">
                    <ContactForm formStyle="contact-form-1" />
                </div>
            </div>
        </>
    )
}
export default ContactOne;